<template>
    <transition name="modal custom-modal">
      <div class="modal-mask modal-lg">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-header">
              <button type="button" class="close" @click="$emit('close')">
                <span aria-hidden="true">×</span><span class="sr-only">Close</span>
              </button>
              <h3 style="width: initial;"><i class="fa fa-lg fa-address-card"></i> {{ leadId }}</h3>
            </div>
            <div class="modal-body pre-scrollable" v-bind:style="{'max-height': bodyHeight + 'px'}">
              <div class="lead-detail">
                <div v-if="!lead" class="text-center panel-body">
                  <p class="well">Loading...</p>
                </div>
                <div v-else class="panel-body">
                  <div v-if="lead.contact" class="col-xs-12 bg-dark lead-data">
                    <h4>Contact Information</h4>
                    <ul class="contact-info">
                      <li v-for="contact_email in lead.contact.email"><i class="fa fa-lg fa-at"></i> <b>{{ contact_email }}</b></li>
                      <li v-for="contact_phone in lead.contact.phone"><i class="fa fa-lg fa-phone"></i> <b>{{ contact_phone }}</b></li>
                      <li v-if="lead.contact.address"><i class="fa fa-lg fa-map-marker"></i> <b>{{ lead.contact.address }}, {{ lead.contact.zip }}, {{ lead.contact.state }}</b></li>
                    </ul>
                  </div>
                  <!-- <div v-if="lead.filters_applied.length" class="col-xs-12 bg-dark lead-data">
                       <h4>Filters Applied</h4>
                       <ul>
                       <li v-for="fa in lead.filters_applied">{{ renderFilter(fa) }}</li>
                       </ul>
                       </div> -->
                  <div v-if="lead.phones_validation.length" class="col-xs-12 bg-dark lead-data">
                    <h4>Phone Validation</h4>
                    <div v-for="pv in lead.phones_validation" class="col-xs-12 col-lg-6 fields-list-wrapper">
                      <h5 class="service-title">{{ pv.field }}: {{ pv.phone_number }} <yes-no :ok="pv.phone_is_valid" /></h5>
                      <table class="table">
                        <tbody>
                          <tr><td>Phone Type</td><th>{{ pv.validation.carrier_phone_type }}</th></tr>
                          <tr><td>Carrier</td><th>{{ pv.validation.carrier_name }}</th></tr>
                          <tr><td>Error</td><th>{{ pv.validation.error }}</th></tr>
                          <tr><td>Service</td><th>{{ pv.validation.validation_service }}</th></tr>
                          <tr v-if="pv.validation.validation_service == 'trestle'"><td>Activity Score</td><th>{{ pv.validation.trestle_activity_score }}</th></tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-xs-12 bg-dark lead-data">
                    <h4>Metadata <button class="btn btn-sm btn-default" @click="fetchLead"><i class="fa fa-refresh"></i> Refresh</button></h4>
                    <ul class="contact-info">
                      <li><i class="fa fa-lg fa-clock-o"></i> Created at: <b>{{ lead.timestamp|formatTimestamp }}</b></li>
                      <li>Current Status: <span class="current-status">{{ currentStatus.code }}</span> [<small>{{ currentStatus.timestamp|formatTimestamp }}</small>]
                        <button :disabled="deliveryStatus" v-if="retryDeliveryAllowed" type="button" class="btn btn-xs btn-default" @click="retryDelivery">
                          <i v-if="deliveryStatus == 'working'" class="fa fa-cog fa-spin fa-fw"></i>
                          <i v-else-if="deliveryStatus == 'ok'" class="fa fa-check-circle"></i>
                          <i v-else-if="deliveryStatus == 'error'" class="fa fa-exclamation-triangle"></i>
                          <i v-else class="fa fa-paper-plane-o"></i>
                          Retry</button>
                      </li>
                      <li>Filtered: <i v-if="lead.filtered" class="fa fa-lg fa-check-square-o"></i><i v-else class="fa fa-lg fa-square-o"></i></li>
                      <li>Duplicate: <i v-if="lead.is_dupe" class="fa fa-lg fa-check-square-o"></i><i v-else class="fa fa-lg fa-square-o"></i></li>
                    </ul>
                    <a role="button" @click="showStatusHistory = !showStatusHistory"><span v-if="showStatusHistory">Hide</span><span v-else>Show</span> status history</a>
                    <table v-if="showStatusHistory" class="table">
                      <tbody>
                        <tr v-for="entry in lead.status_history">
                          <td>{{entry.timestamp|formatTimestamp}}</td>
                          <td class="status-entry">{{entry.code}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="col-xs-12 bg-dark lead-data" v-if="lead.appointments">
                    <h4>Appointments</h4>

                    <div v-for="appointment in lead.appointments" class="col-xs-12 fields-list-wrapper">
                      <h5 class="service-title">{{ appointment.type_pretty }} <span class="badge badge-primary" v-if="appointment.is_current">CURRENT</span></h5>
                      <table class="table">
                        <tbody>
                          <tr><th>ID</th><td>{{ appointment.id }}</td></tr>
                          <tr><th>Agent</th><td>[{{appointment.agent.npn }}] {{ appointment.agent.name }}</td></tr>
                          <tr><th>Status</th><td><span class="current-status">{{ appointment.current_status.pretty_code }}</span> ({{ appointment.current_status.timestamp|formatTimestamp }})</td></tr>
                          <tr><th>Local Timestamp</th><td>{{ appointment.start_timestamp_pretty }} ({{appointment.duration_display}})</td></tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div v-if="lead.facebook_lead" class="col-xs-12 bg-dark lead-data">
                    <h4><i class="fa fa-facebook-official"></i> Facebook Lead Data</h4>
                    <div class="col-xs-12 fields-list-wrapper">

                      <table class="table">
                        <tbody>
                          <tr>
                            <td>Timestamp</td>
                            <td><b>{{ lead.facebook_lead.fb_created_time|formatTimestamp }}</b></td>
                          </tr>
                          <tr>
                            <td>Lead Id</td>
                            <td><b>{{ lead.facebook_lead.fb_id }}</b></td>
                          </tr>
                          <tr>
                            <td>Ad Id</td>
                            <td><b>{{ lead.facebook_lead.fb_ad_id }}</b></td>
                          </tr>
                          <tr>
                            <td>Form Id</td>
                            <td><b>{{ lead.facebook_lead.fb_form.fb_form_id }}</b></td>
                          </tr>
                          <tr>
                            <td>Page Id</td>
                            <td><b>{{ lead.facebook_lead.fb_form.fb_page.fb_page_id }}</b></td>
                          </tr>
                          <tr>
                            <td>Page Name</td>
                            <td><b>{{ lead.facebook_lead.fb_form.fb_page.fb_page_name }}</b></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div v-if="lead.google_lead" class="col-xs-12 bg-dark lead-data">
                    <h4><i class="fa fa-google"></i> Google Lead Data</h4>
                    <div class="col-xs-12 fields-list-wrapper">

                      <table class="table">
                        <tbody>
                          <tr>
                            <td>Lead Id</td>
                            <td><b>{{ lead.google_lead.lead_id }}</b></td>
                          </tr>
                          <tr>
                            <td>Form Id</td>
                            <td><b>{{ lead.google_lead.form_id }}</b></td>
                          </tr>
                          <tr>
                            <td>Campaign Id</td>
                            <td><b>{{ lead.google_lead.campaign_id }}</b></td>
                          </tr>
                          <tr>
                            <td>AdGroup Id</td>
                            <td><b>{{ lead.google_lead.adgroup_id }}</b></td>
                          </tr>
                          <tr>
                            <td>Creative Id</td>
                            <td><b>{{ lead.google_lead.creative_id }}</b></td>
                          </tr>
                          <tr>
                            <td>GCL Id</td>
                            <td><b>{{ lead.google_lead.gcl_id }}</b></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="col-xs-12 bg-dark lead-data">
                    <h4>Grades <button v-if="$store.state.user.current_account.allow_score_on_demand" type="button" class="btn btn-primary" @click="scoreLead">
                      <i v-show="!scoring" class="fa fa-lg fa-star"></i>
                      <i v-show="scoring" class="fa fa-lg fa-cog fa-spin fa-fw"></i> Grade Lead</button></h4>
                    <p v-if="!lead.grades.length">This lead has not been graded</p>
                    <div v-for="v,k in lead.grades" class="col-xs-offset-2 col-xs-8 lead-scores">
                      <h4>{{ v.scoring_model }} <span v-if="v.is_main" class="badge badge-primary">MAIN</span></h4>
                      <table>
                        <tr>
                          <td>Multiplier: <span class="score-model-name"><b>{{ v.multiplier }}</b></span></td>
                          <td class="score-value text-center" colspan="2" rowspan="2">{{ v.label }}</td>
                        </tr>
                        <tr>
                          <td clas="score-model-date"><small>{{ v.created|formatTimestamp }}</small></td>
                        </tr>
                      </table>

                    </div>
                  </div>
                  <div v-if="lead.appended_data.length" class="col-xs-12 bg-dark lead-data">
                    <h4>Appended Data</h4>
                    <div v-for="d in lead.appended_data" class="col-xs-12 fields-list-wrapper">
                      <h5 class="service-title">{{ d.service }}</h5>
                      <table class="table">
                        <thead>
                          <tr>
                            <th>Field</th><th>Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="v, k in d.response"><td>{{ k }}</td><td><b>{{ v }}</b></td></tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="col-xs-12 bg-dark lead-data">
                    <h4>Lead Data</h4>
                    <div class="col-xs-12 col-md-6 fields-list-wrapper">
                      <h5 class="service-title">Form Data</h5>
                      <table class="table">
                        <thead>
                          <tr>
                            <th>Field</th><th>Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="v, k in lead.fields"><td>{{ k }}</td><td><b>{{ v }}</b></td></tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-xs-12 col-md-6 fields-list-wrapper">
                      <h5 class="service-title">CRM Data</h5>
                      <table class="table">
                        <thead>
                          <tr>
                            <th>Field</th><th>Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="v, k in lead.crm_fields"><td>{{ k }}</td><td><b>{{ v }}</b></td></tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
</template>


<script>
 var _ = require('lodash');

 import YesNo from 'components/elements/YesNo';
 export default {
   components: {
     YesNo
   },
   name: 'LeadDataModal',
   props: {
     leadId: {
       type: String
     }
   },
   data: function () {
     return {
       lead: null,
       scoring: false,
       showStatusHistory: false,
       deliveryStatus: null,
     };
   },
    computed: {
      retryDeliveryAllowed() {
        const retryableStatuses = ['delivery_skipped', 'delivery_error', 'rejected'];
        return retryableStatuses.includes(this.currentStatus.code);
      },
      bodyHeight () {
        return $(window).height() - 200;
      },
      currentStatus() {
        if (this.lead.status_history && this.lead.status_history.length) {
          return this.lead.status_history[0]
        }
        return {'code': '', 'timestamp': null};
      }
    },
    created() {
      this.fetchLead();
    },
    methods: {
      async fetchLead() {
        this.lead = null;
        try {
          const res = await API.leads.getLead(this.leadId);
          this.lead = res.body;
        } catch (e) {
          // TODO: Handle error!
          this.$emit('close');
        }

      },
     renderFilter(f) {
       if (!f.filter) {
         return '';
       }
       return _.join(
         _.map(f.filter.predicate.allof.terms, function (term) {
           return _.join(
             _.map(term.rules, function (rule) {
               var vs = '';
               if (_.isArray(rule.values)) {
                 vs =_.join( _.slice(rule.values, 0, 2), ', ');
                 if (rule.values.length > 2) {
                   vs = vs + ', ...';
                 }
               }
               else if (rule.vales) {
                 vs = rule.values;
               }
               return rule.field.name + ' ' + rule.op.label + ' ' + rule.values;
             }),
             ' or '
           )
         }),
         ' and ');
     },
     formatDate(d) {
       return moment(d).format("MM/DD/YYYY HH:mm:ss");
     },

     scoreLead() {
       var self = this;
       this.scoring = true;
       API.leads.scoreLead(self.lead.id)
          .then(function (response) {
            self.lead = response.body;
            self.scoring = false;
          })
          .error(function () {
            self.scoring = false;
          });
     },
     async retryDelivery() {
       if (!this.deliveryStatus) {
         this.deliveryStatus = 'working';
         try {
           const res = await API.leads.retryDelivery(this.lead.id);
           this.deliveryStatus = res.body.acknowledged ? 'ok' : 'error';
         } catch (e) {
           this.deliveryStatus = 'error';
         }
       }
     }
   }
 }
</script>
<style scoped>
  .panel-body div.lead-data + div {
  margin-top: 30px;
  }

 .modal-header h3 {
  text-transform: unset!important;
  }

  .lead-detail .panel-body h4 button {
  right: 20px;
  top: 10px;
  position: absolute;
  }

  .lead-detail .panel-body > div {
  padding: 10px 20px;
  }

  .lead-detail .panel-body > div.fields-list-wrapper {
  padding: 0px;
  }

  .lead-detail h4 {
  padding-bottom: 10px;
  }

  .bg-dark {
  background-color: #f7f7f7;
  border-radius: 4px 4px;
  }

 ul {
     list-style: none;
 }

 ul li i {
     color: #aaa;
 }

 ul.contact-info li > i {
  color: #aaa;
 }

 ul > li::before {
     content: "";
     display: inline-block;
     vertical-align: middle;
     border: 1px solid #dadada;
     width: .75em;
     margin-left: 20px;
     margin-right: 20px;
 }

 ul.contact-info > li:not(:first-child)::before {
     content: "";
     display: inline-block;
     vertical-align: middle;
     border: 1px solid #dadada;
     width: .75em;
     margin-left: 20px;
     margin-right: 20px;
 }

 ul.contact-info li {
  display: inline-block;
 }

  .score-model-name {
  font-weight: 700;
  }
  .score-model-date {
  font-weight: 700;
  }
  .score-value {
  font-weight: 700;
  font-size: 2.75em;
  color: #ff4d50;
  text-align: left;
  padding-left: 30px;
  min-width: 50%;
  }

 .current-status {
     font-weight: 700;
     font-size: 125%;
     color: #ff4d50;
     text-transform: uppercase;
 }

 .status-entry {
     font-weight: 700;
     text-transform: uppercase;
 }
  .fields-list-wrapper > div {
  padding: 10px 20px;
  }

  .fields-list-wrapper > div.lead-fields {
  margin-right: 10px;
  }

  .fields-list-wrapper div.crm-fields {
  margin-left: 10px;
  }

  .lead-detail table {
  border-radius: 4px;
  }

  .lead-detail .table > tbody > tr > td {
  padding: 10px 10px;
  }

  .lead-detail th {
  background-color: initial;
  color: initial;
  }

  .service-title {
    text-transform: uppercase;
  }

  .lead-data table {
    overflow-x: auto;
  }

</style>



// WEBPACK FOOTER //
// LeadDataModal.vue?16160f0d